import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DisplayValueDescriptor } from '../../../../common-pipes/display-value.pipe';

// The direction the caret will face
export enum CHANGE_DIRECTION {
  NO_CHANGE,
  UPWARD_CHANGE,
  DOWNWARD_CHANGE,
}

// The color of the change
export enum CHANGE_TYPE {
  NO_CHANGE,
  POSITIVE_CHANGE,
  NEGATIVE_CHANGE,
}

export interface NumberWithChangeConfig {
  currentPeriod: DisplayValueDescriptor;
  previousPeriod?: DisplayValueDescriptor;
  previousPeriodChangeDirection?: CHANGE_DIRECTION;
  previousPeriodChangeType?: CHANGE_TYPE;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'number-with-change, div[number-with-change]',
  templateUrl: './number-with-change.component.html',
  styleUrls: ['./number-with-change.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberWithChangeComponent {
  @Input()
  changeInfo: NumberWithChangeConfig;

  changeType = CHANGE_TYPE;
  changeDirection = CHANGE_DIRECTION;
}
